<article class="ticket" [class]="'ticket--' + status" [class.ticket--removal]="onlyRemovals" [attr.aria-busy]="item.busy">
  <header class="ticket__head">
    <h3 class="ticket__title">{{ item.action.summary.title }}</h3>
  </header>

  <ul class="ticket__changes">
    @for (change of visibleChanges; track $index) {
      <li class="change" [class.change--removed]="change.removed">
        @if (showTargets) {
          <div class="change__target">{{ change.target }}</div>
        }

        @if (change.textChange) {
          <assistant-text-change [change]="change.textChange"></assistant-text-change>
        }

        @if (change.period) {
          <div class="change__price-line">
            <span class="change__period">{{ change.period }}</span>
            <span class="change__price">
              @if (change.priceBefore) {
                <del class="change__price-before">{{ change.priceBefore }}</del>
              }
              @if (change.removed) {
                <span class="change__removed">{{ 'Da eliminare' | translate }}</span>
              } @else {
                <ins class="change__price-after">{{ change.priceAfter }}</ins>
              }
            </span>
          </div>
        }

        @if (change.rows.length) {
          <dl class="change__rows">
            @for (row of change.rows; track row.label) {
              <div class="change__row">
                <dt>{{ row.label | translate }}</dt>
                <dd>
                  @if (row.before) {
                    <del>{{ row.before }}</del>
                  }
                  <ins>{{ row.after }}</ins>
                </dd>
              </div>
            }
          </dl>
        }

        @if (change.note) {
          <p class="change__note">{{ change.note }}</p>
        }
      </li>
    }
  </ul>

  @if (hiddenCount > 0) {
    <button type="button" class="ticket__more" (click)="expanded = true">
      {{ 'Mostra tutte le modifiche' | translate }} ({{ changes.length }})
    </button>
  }

  @if (item.action.summary.notes?.length) {
    <ul class="ticket__notes">
      @for (note of item.action.summary.notes; track $index) {
        <li>{{ note }}</li>
      }
    </ul>
  }

  <div class="ticket__tear" aria-hidden="true"></div>

  <footer class="ticket__foot">
    @switch (status) {
      @case ('pending') {
        <p class="ticket__hint">{{ 'Nessun dato è stato ancora modificato.' | translate }}</p>
        <div class="ticket__actions">
          <button mat-button type="button" class="ticket__cancel" [disabled]="item.busy" (click)="cancel.emit(item)">
            {{ 'Annulla' | translate }}
          </button>
          <button mat-flat-button type="button" class="ticket__apply" [disabled]="item.busy" (click)="confirm.emit(item)">
            @if (item.busy) {
              <mat-spinner diameter="16" class="ticket__spinner"></mat-spinner>
            }
            {{ (onlyRemovals ? 'Elimina' : 'Applica') | translate }}
          </button>
        </div>
      }
      @case ('confirmed') {
        <p class="ticket__outcome ticket__outcome--ok">
          <mat-icon inline>check_circle</mat-icon>
          {{ 'Applicata alle' | translate }} {{ item.outcome?.at | date: 'HH:mm' }}
        </p>
      }
      @case ('canceled') {
        @if (item.action.withdrawn_by_assistant) {
          <p class="ticket__outcome">
            {{ 'Ritirata dall\'assistente: nessuna modifica applicata.' | translate }}
            @if (item.action.withdrawn_reason) {
              <span class="ticket__outcome-reason">{{ item.action.withdrawn_reason }}</span>
            }
          </p>
        } @else {
          <p class="ticket__outcome">{{ 'Annullata: nessuna modifica applicata.' | translate }}</p>
        }
      }
      @case ('expired') {
        <p class="ticket__outcome">{{ 'Proposta scaduta: chiedi di nuovo all\'assistente.' | translate }}</p>
      }
      @case ('failed') {
        <p class="ticket__outcome ticket__outcome--error">{{ item.actionError || ('La modifica non è stata applicata.' | translate) }}</p>
      }
    }
    @if (item.actionError && status === 'pending') {
      <p class="ticket__outcome ticket__outcome--error" role="alert">{{ item.actionError }}</p>
    }
  </footer>
</article>
